import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { Button, Card, DataTable, StatusBadge } from '../UI';

const columns = [
  { name: 'Name', cell: (row) => <Link to={`/transfer-hubs/${row.id}`}>{row.name}</Link> },
  { name: 'Lat', selector: 'lat' },
  { name: 'Lng', selector: 'lng' },
  { name: 'Radius (m)', selector: 'radius_meters' },
  {
    name: 'Active',
    cell: (row) =>
      row.active ? (
        <StatusBadge tone="success">Active</StatusBadge>
      ) : (
        <StatusBadge tone="neutral">Inactive</StatusBadge>
      ),
  },
];

export default function HubsList() {
  const [hubs, setHubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData(Endpoints.LIST_TRANSFER_HUBS)
      .then((res) => res.json())
      .then((res) => {
        const list = (res && res.data) || res || [];
        setHubs(Array.isArray(list) ? list : []);
        setLoading(false);
      });
  }, []);

  return (
    <PageLayout
      title="Transfer hubs"
      actions={
        <Link to="/transfer-hubs/new">
          <Button>Add hub</Button>
        </Link>
      }
    >
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={hubs}
          progressPending={loading}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
